import { Component, Input } from '@angular/core';
import { KbaResult } from '../../models';

@Component({
    selector: 'app-kba-results',
    templateUrl: './kba-results.component.html',
    styleUrl: './kba-results.component.scss',
    standalone: false
})
export class KbaResultsComponent {
  @Input() kbaResults: KbaResult;

  get kbaStatus(): string {
    return this.kbaResults.isSuccess ? "Passed" : "Failed";
  }
}
